const RegisterWrap = () => import(/* webpackChunkName: "RegisterWrap" */'../views/Register/index.vue')
const Identity = () => import(/* webpackChunkName: "RegisterWrap" */'../views/Register/Comp/Identity.vue')
const RegPhone = () => import(/* webpackChunkName: "RegPhone" */'../views/Register/Comp/RegPhone.vue')
const StoreApplication = () => import(/* webpackChunkName: "StoreApplication" */'../views/Register/Comp/StoreApplication.vue')
const PersonLregister = () => import(/* webpackChunkName: "RegPhone" */'../views/Register/Comp/PersonLregister.vue')
const RegDocuments = () => import(/* webpackChunkName: "RegDocuments" */'../views/Register/Comp/RegDocuments/RegDocumentsWrap.vue')
const RegWechat = () => import(/* webpackChunkName: "RegWechat" */'../views/Register/Comp/RegWechat.vue')
const RegBasicWrap = () => import(/* webpackChunkName: "RegBasicWrap" */'../views/Register/Comp/RegBasicWrap.vue')
const RegBasicType = () => import(/* webpackChunkName: "RegBasicType" */'../views/Register/Comp/RegBasicType.vue')
const RegBasicClose = () => import(/* webpackChunkName: "RegBasicType" */'../views/Register/Comp/RegBasicClose.vue')
const StorePhotos = () => import(/* webpackChunkName: "StorePhotos" */'../views/StoreInfo/BasicInfo/Comps/StorePhotos.vue')
const RoomMeetLists = () => import(/* webpackChunkName: "RoomMeetLists" */'../views/StoreInfo/RoomMeetsInfo/Comps/RoomMeetLists.vue')
const SubmitVerify = () => import(/* webpackChunkName: "SubmitVerify" */'../views/StoreInfo/BasicInfo/Comps/SubmitVerify.vue')

export default [
  {
    path: '/register',
    component: RegisterWrap,
    children: [
      { path: 'identity', component: Identity,name:'identity', meta: { title: '订单雨-注册身份' ,navigateName:'选择身份'}},
      // { path: 'reg',name:'regPhone', component: RegPhone, meta: { title: '订单雨-用户注册',navigateName:'供应商-酒店注册' }},
      { path: 'reg-person',name:'PersonLregister', component: PersonLregister, meta: { title: '订单雨-用户注册',navigateName:'用户注册' } },
      { path: 'store-application',name:'StoreApplication', component: StoreApplication, meta: { title: '订单雨-申请企业',navigateName:'申请企业' } },
      { path: 'reset',name:'resetPwd', component: RegPhone, meta: { title: '订单雨-找回密码',navigateName:'重置密码' } },
      { path: 'documents',name:'regDoc', component: RegDocuments, meta: { title: '订单雨-用户协议',navigateName:'用户协议' } },
      { path: 'wechat', name:'regWechat',component: RegWechat, meta: { title: '订单雨-微信绑定',navigateName:'微信绑定' } },
      { path: 'basic-close', name: 'regBasicClose' ,component: RegBasicClose, meta: { title: '订单雨-关联酒店',navigateName:'加入酒店' } },
      {
        path: 'basic',
        component: RegBasicWrap,
        meta: { title: '订单雨-完善信息' },
        children: [
          { path: 'basic-info', name: 'resBasicInfo' ,component: RegBasicType, meta: { title: '订单雨-基础信息',navigateName:'基础信息' } },
          { path: 'store-photos', name: 'regStorePhotos' , component: StorePhotos, meta: { title: '订单雨-门店相册',navigateName:'门店相册' } },
          { path: 'room-lists', name: 'regRoomLists' ,component: RoomMeetLists, meta: { title: '订单雨-房型信息',navigateName:'门店房型' } },
          { path: 'meet-lists', name: 'regMeetLists' ,component: RoomMeetLists, meta: { title: '订单雨-会议室信息',navigateName:'门店会议室' } },
          { path: 'reg-verify', name: 'regVerify', component: SubmitVerify, meta: { title: '订单雨-门店认证',navigateName:'门店认证' } },
        ] },
    ]
  }
]
